enum SeedOrdersRoutes {
  List = '/seed-orders',
  SeedOrderDetails = '/seed-orders/:id',
  SeedOrderAdd = '/seed-orders/add',
  SeedOrderEdit = '/seed-orders/:id/edit',
}

export default SeedOrdersRoutes
